import { FileInfo, NamedProperty, Optional } from "sprint-common-web";

import { ContentDetails } from "../../../../types/ContentDetails";
import { RecordType } from "../../../../types/RecordType";

export type GetCloudFileDetailsResponse =
    | GetCloudFileVideoDetailsResponse
    | GetCloudFileAudioDetailsResponse
    | GetCloudFileSubtitleDetailsResponse;

interface BaseGetCloudFileDetailsResponse {
    id: string;
    filePath: string;
    status: number;
    isBeingProcessed?: boolean;
    content: Optional<ContentDetails>;
    delivery: CloudFileDeliveryInfoResponse;
    isNotificationApproved?: boolean;
    fileRecordId?: string;
    lastUpdatedBy?: string;
    statusDetails?: CloudFileStatusDetailsResponse;
    isTrailer: boolean;
}

interface GetCloudFileVideoDetailsResponse extends BaseGetCloudFileDetailsResponse {
    recordType: RecordType.Video;
    aspectType?: NamedProperty;
    aspectRatio?: NamedProperty;
    subtitleLanguageId?: string;
    soundtrackLanguageId?: string;
    technical?: {
        duration?: string;
        framerate?: string;
        width?: number;
        height?: number;
        fileAspectRatio?: string;
        encoding?: string;
        videoBitRate?: number;
        format?: string;
    };
}

interface GetCloudFileAudioDetailsResponse extends BaseGetCloudFileDetailsResponse {
    recordType: RecordType.Audio;
    soundtrackLanguageId?: string;
    technical?: {
        duration?: string;
        channelsCount?: number;
        audioFormat?: string;
        sampleRate?: number;
        audioBitRate?: number;
    };
}

interface GetCloudFileSubtitleDetailsResponse extends BaseGetCloudFileDetailsResponse {
    recordType: RecordType.Subtitle;
    subtitleLanguageId?: string;
}

interface CloudFileDeliveryInfoResponse {
    deliveryId: string;
    arrivalDate: string;
    type: number;
    file: FileInfo;
    sender: CloudFileSenderInfoResponse | undefined;
    originator: NamedProperty | undefined;
    reference: string | undefined;
}

interface CloudFileSenderInfoResponse {
    name?: string;
    email?: string;
    subject?: string;
    message?: string;
}

type CloudFileStatusDetailsResponse = {
    reason?: string;
    details?: string;
    courseOfAction?: string;
    fixedBilling?: string;
};

export const isVideoCloudFileDetailsResponse = (
    details: GetCloudFileDetailsResponse
): details is GetCloudFileVideoDetailsResponse => details.recordType === RecordType.Video;

export const isAudioCloudFileDetailsResponse = (
    details: GetCloudFileDetailsResponse
): details is GetCloudFileAudioDetailsResponse => details.recordType === RecordType.Audio;

export const isSubtitleCloudFileDetailsResponse = (
    details: GetCloudFileDetailsResponse
): details is GetCloudFileSubtitleDetailsResponse => details.recordType === RecordType.Subtitle;
